import type { ReactNode } from "react";
import classnames from "classnames";
import { Table as TableV2 } from "@circle-react-uikit/TableV2";
import { useDataTableDataProvider } from "../Provider/DataTableDataProvider";

export interface TableProps {
  children: ReactNode;
  className?: string;
}

export const Table = ({ children, className }: TableProps) => {
  const { isLoading } = useDataTableDataProvider();

  return (
    <TableV2
      className={classnames(className, {
        "cursor-wait": isLoading,
      })}
    >
      {children}
    </TableV2>
  );
};
